(() => {
  if (window.liliNavigationDraftBound) return;
  window.liliNavigationDraftBound = true;
  let handledEscape = false;
  const close = (item, restore = false) => {
    const button = item.querySelector('[data-lln-toggle]');
    const panel = button && document.getElementById(button.getAttribute('aria-controls'));
    if (!button || !panel) return;
    button.setAttribute('aria-expanded', 'false'); panel.hidden = true;
    if (restore) button.focus();
  };
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-lln-toggle]');
    document.querySelectorAll('[data-lln-item]').forEach(item => {
      if (!item.contains(event.target)) close(item);
    });
    if (!toggle) return;
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(open)); panel.hidden = !open;
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const item = event.target.closest('[data-lln-item]');
    if (item && item.querySelector('[aria-expanded="true"]')) {handledEscape = true; close(item, true); event.preventDefault(); event.stopPropagation();}
  });
  // Consume only the keyup belonging to our desktop disclosure. The legacy
  // theme otherwise attempts to close a nonexistent slideout/modal on Escape.
  document.addEventListener('keyup', event => {
    if (event.key === 'Escape' && handledEscape) {
      handledEscape = false; event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('focusin', event => {
    document.querySelectorAll('[data-lln-item]').forEach(item => {if (!item.contains(event.target)) close(item);});
  });
})();
